module.exports = __webpack_public_path__ + "img/4f68f2860885ae60f09b6db0f654fbb8.png";


//////////////////
// WEBPACK FOOTER
// ./components/levels/levelPrologue/assets/images/foreground.png
// module id = 81
// module chunks = 0